import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

function handleClick(active, closeSidePanel, openSidePanel) {
  if (active) {
    closeSidePanel();
  } else {
    openSidePanel();
  }
}

function handleMouseLeave(id) {
  document.getElementById(id).blur();
}

export default function EnhancementButton({
  active,
  canShow,
  onFocus,
  attributeId,
  heading,
  closeSidePanel,
  openSidePanel,
  restoreFocus,
}) {
  const enhancementButton = useRef(null);

  if (!canShow) {
    return null;
  }

  if (restoreFocus && enhancementButton.current) {
    enhancementButton.current.focus();
  }

  return (
    <button
      className={classnames('enhancement-button u-margin-m-right', { active })}
      onClick={() => handleClick(active, closeSidePanel, openSidePanel)}
      onMouseLeave={() => handleMouseLeave(`expand-${attributeId}-button`)}
      title={`Toggle ${attributeId} panel`}
      type="button"
      aria-pressed={active}
      onFocus={onFocus}
      id={`expand-${attributeId}-button`}
      ref={enhancementButton}
    >
      <span>{heading}</span>
    </button>
  );
}

EnhancementButton.propTypes = {
  active: PropTypes.bool,
  openSidePanel: PropTypes.func.isRequired,
  closeSidePanel: PropTypes.func.isRequired,
  onFocus: PropTypes.func,// eslint-disable-line
  canShow: PropTypes.bool,
  heading: PropTypes.string.isRequired,
  attributeId: PropTypes.string.isRequired,
  restoreFocus: PropTypes.bool.isRequired,
};

EnhancementButton.defaultProps = {
  active: false,
  canShow: false,
};
